module.exports = __webpack_public_path__ + "static/media/doclad17.9dfca85a.pdf";